<template>
  <div>
    <!-- Hero Section - Clean Modern Design -->
    <section class="hero-section">
      <!-- Simple Background with Particles -->
      <ParticlesBackground class="hero-particles" />
      
      <!-- Main Content Container -->
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <!-- Left Column - Content -->
          <div class="col-lg-6 hero-content">
            <!-- Tag Pill -->
            <div class="hero-tag">
              <div class="hero-tag-icon">
                <i class="bi bi-shield-check"></i>
              </div>
              <div class="hero-tag-text">INTELLECTUAL PROPERTY EXPERTS</div>
            </div>
            
            <!-- Main Heading -->
            <h1 class="hero-title">
              <span class="hero-title-small">Securing the Future of</span>
              <span class="hero-title-main">
                <span class="text-gradient">Biotech</span> <span class="text-white">Innovation</span>
              </span>
            </h1>
            
            <!-- Description -->
            <p class="hero-description">
              Pioneering intellectual property strategies that transform scientific breakthroughs into protected assets. Where scientific precision meets legal expertise to safeguard tomorrow's innovations.
            </p>
            
            <!-- Stats Row -->
            <div class="hero-stats">
              <div class="hero-stat">
                <div class="stat-number">25+</div>
                <div class="stat-label">Years Experience</div>
              </div>
              <div class="hero-stat">
                <div class="stat-number">100+</div>
                <div class="stat-label">Patents Secured</div>
              </div>
            </div>
            
            <!-- CTA Button -->
            <div class="hero-cta">
              <router-link to="/services" class="btn-primary">
                Our Services
                <i class="bi bi-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
          
          <!-- Right Column - Visual space, DNA animation removed -->
          <div class="col-lg-6 d-none d-lg-block">
            <div class="hero-visual">
              <!-- DNA Animation removed -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Overview -->
    <section class="services-section py-6">
      <div class="services-bg"></div>
      <div class="container position-relative">
        <div class="section-header text-center mb-5" data-aos="fade-up">
          <h6 class="section-pre-title">SPECIALIZED EXPERTISE</h6>
          <h2 class="section-title">My <span class="text-gradient">Expertise</span></h2>
          <div class="section-line"></div>
          <p class="section-subtitle mx-auto">Leveraging scientific knowledge and legal acumen to protect your most valuable biotech assets</p>
        </div>
        
        <div class="services-grid">
          <div class="service-card" data-aos="fade-up" data-aos-delay="100">
            <div class="service-card-inner">
              <div class="service-icon">
                <div class="icon-hexagon">
                  <i class="bi bi-lightbulb"></i>
                </div>
                <div class="icon-glow"></div>
              </div>
              <div class="service-content">
                <h3>Patent Strategy</h3>
                <p>Comprehensive patent portfolio development and management for biotech innovations that drive industry change.</p>
                <router-link to="/services" class="service-link">
                  <span>Explore Strategy</span>
                  <i class="bi bi-arrow-right"></i>
                </router-link>
              </div>
              <div class="service-hover-effect"></div>
            </div>
          </div>
          
          <div class="service-card" data-aos="fade-up" data-aos-delay="200">
            <div class="service-card-inner">
              <div class="service-icon">
                <div class="icon-hexagon">
                  <i class="bi bi-file-earmark-text"></i>
                </div>
                <div class="icon-glow"></div>
              </div>
              <div class="service-content">
                <h3>IP Due Diligence</h3>
                <p>Thorough analysis of intellectual property assets for investments and partnerships with precision and insight.</p>
                <router-link to="/services" class="service-link">
                  <span>Discover Process</span>
                  <i class="bi bi-arrow-right"></i>
                </router-link>
              </div>
              <div class="service-hover-effect"></div>
            </div>
          </div>
          
          <div class="service-card" data-aos="fade-up" data-aos-delay="300">
            <div class="service-card-inner">
              <div class="service-icon">
                <div class="icon-hexagon">
                  <i class="bi bi-clipboard-check"></i>
                </div>
                <div class="icon-glow"></div>
              </div>
              <div class="service-content">
                <h3>Regulatory Compliance</h3>
                <p>Navigate complex regulatory landscapes while protecting your intellectual property with strategic expertise.</p>
                <router-link to="/services" class="service-link">
                  <span>Learn Approach</span>
                  <i class="bi bi-arrow-right"></i>
                </router-link>
              </div>
              <div class="service-hover-effect"></div>
            </div>
          </div>
          

        </div>
        
        <div class="text-center mt-5" data-aos="fade-up" data-aos-delay="500">
          <router-link to="/services" class="btn-services-explore">
            <span>Explore All Services</span>
            <i class="bi bi-arrow-right-circle-fill ms-2"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- About Ken Section -->
    <section class="about-section py-6 bg-light">
      <div class="container position-relative">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="founder-card bg-white rounded-4 shadow-sm overflow-hidden">
              <div class="row g-0">
                <!-- Left Column - Profile Info -->
                <div class="col-md-4 border-end">
                  <div class="founder-left-column p-4 h-100 d-flex flex-column">
                    <div class="text-center mb-4">
                      <img src="/images/kenprofilepic.jpeg" alt="Kenneth Peist" class="rounded-4 img-fluid founder-image mb-4" style="max-width: 85%; object-fit: cover;">
                    </div>
                    
                    <div class="founder-stats mb-4">
                      <div class="stat-badge d-flex align-items-center bg-light rounded-3 p-3 mb-3">
                        <div class="stat-icon bg-primary rounded-circle text-white me-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                          <i class="bi bi-award"></i>
                        </div>
                        <div>
                          <div class="stat-value fw-bold fs-4 text-primary">25+</div>
                          <div class="stat-label text-muted small">YEARS EXPERIENCE</div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="founder-credentials mb-4">
                      <div class="credential-item d-flex align-items-center mb-3">
                        <div class="credential-icon bg-light rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                          <i class="bi bi-mortarboard text-primary"></i>
                        </div>
                        <div class="credential-text small">J.D., Intellectual Property Law</div>
                      </div>
                      <div class="credential-item d-flex align-items-center">
                        <div class="credential-icon bg-light rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                          <i class="bi bi-briefcase text-primary"></i>
                        </div>
                        <div class="credential-text small">Biotech IP Specialist</div>
                      </div>
                    </div>
                    
                    <div class="founder-social mt-auto">
                      <div class="d-flex">
                        <a href="https://www.linkedin.com/in/kenneth-peist/" target="_blank" class="social-link bg-light rounded-circle d-flex align-items-center justify-content-center me-2" style="width: 40px; height: 40px;">
                          <i class="bi bi-linkedin text-primary"></i>
                        </a>
                        <a href="mailto:ken@peistbiotechip.com" class="social-link bg-light rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                          <i class="bi bi-envelope text-primary"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- Right Column - Bio Content -->
                <div class="col-md-8">
                  <div class="founder-right-column p-4 p-lg-5">
                    <div class="founder-header mb-4">
                      <div class="text-muted mb-2">Founder & Principal Consultant</div>
                      <h2 class="mb-3">Hi, I'm <span class="text-gradient">Ken Peist</span>, Esq.</h2>
                    </div>
                    
                    <div class="founder-bio mb-4">
                      <p>With over 25 years of experience in intellectual property law for the biotech and pharmaceutical industries, I founded PEIST Biotech IP Consulting to provide specialized IP services to innovative companies developing life-changing therapeutics.</p>
                      
                      <p>I'm particularly passionate about working with companies developing novel therapeutics that have the potential to transform patient care. My approach combines scientific rigor, legal precision, and business pragmatism to create IP strategies that align with your company's long-term vision.</p>
                    </div>
                    
                    <div class="founder-expertise mb-4">
                      <h5 class="mb-3">Areas of Expertise</h5>
                      <div class="row g-3">
                        <div class="col-md-6">
                          <div class="expertise-item bg-light rounded-3 p-3 d-flex align-items-center">
                            <div class="expertise-icon bg-primary rounded-circle text-white me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                              <i class="bi bi-capsule"></i>
                            </div>
                            <div class="expertise-text">Pharmaceuticals</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="expertise-item bg-light rounded-3 p-3 d-flex align-items-center">
                            <div class="expertise-icon bg-primary rounded-circle text-white me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                              <i class="bi bi-virus"></i>
                            </div>
                            <div class="expertise-text">Biotechnology</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="expertise-item bg-light rounded-3 p-3 d-flex align-items-center">
                            <div class="expertise-icon bg-primary rounded-circle text-white me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                              <i class="bi bi-file-earmark-text"></i>
                            </div>
                            <div class="expertise-text">Patent Strategy</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="expertise-item bg-light rounded-3 p-3 d-flex align-items-center">
                            <div class="expertise-icon bg-primary rounded-circle text-white me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                              <i class="bi bi-diagram-3"></i>
                            </div>
                            <div class="expertise-text">IP Portfolio</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="founder-cta bg-light rounded-3 p-4 text-center">
                      <p class="mb-3">Feel free to connect with me to discuss how I can help your company develop a robust IP strategy.</p>
                      <router-link to="/contact" class="btn btn-primary btn-lg rounded-pill px-4">
                        <i class="bi bi-chat-dots me-2"></i>Schedule a Consultation
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="testimonials-section py-6">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h6 class="section-pre-title">SUCCESS STORIES</h6>
          <h2 class="section-title">What Our <span class="text-gradient">Clients Say</span></h2>
          <div class="section-line"></div>
        </div>
        
        <div class="testimonials-slider">
          <div class="row g-4">
            <div class="col-md-6">
              <div class="testimonial-card">
                <div class="testimonial-rating">
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                </div>
                <div class="testimonial-quote">
                  <i class="bi bi-quote"></i>
                </div>
                <p class="testimonial-text">
                  "Their expertise in biotech patent strategy was invaluable to our startup. They helped us secure crucial IP protection that was key to our successful Series A funding. The team's strategic approach and deep industry knowledge set them apart."
                </p>
                <div class="testimonial-author">
                  <div class="testimonial-author-avatar">
                    <div class="avatar-placeholder">SJ</div>
                  </div>
                  <div class="testimonial-author-info">
                    <h4>Dr. Sarah Johnson</h4>
                    <p>CEO, BioGenetics Inc.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="testimonial-card">
                <div class="testimonial-rating">
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                </div>
                <div class="testimonial-quote">
                  <i class="bi bi-quote"></i>
                </div>
                <p class="testimonial-text">
                  "The team's deep understanding of both the scientific and legal aspects of pharmaceutical IP has been crucial to our product development strategy. Their insights have helped us navigate complex regulatory challenges while maintaining strong IP protection."
                </p>
                <div class="testimonial-author">
                  <div class="testimonial-author-avatar">
                    <div class="avatar-placeholder">MC</div>
                  </div>
                  <div class="testimonial-author-info">
                    <h4>Michael Chen</h4>
                    <p>VP of R&D, PharmaTech Solutions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="cta-section-modern">
      <div class="container position-relative">
        <div class="cta-content-modern text-center">
          <h2 class="cta-title-modern">Ready to Protect Your <span class="text-primary">Innovations</span>?</h2>
          <p class="cta-text-modern mx-auto">
            Contact us today for a consultation and discover how our specialized IP consulting services can help secure your biotech and pharmaceutical innovations.
          </p>
          <router-link to="/contact" class="btn btn-primary btn-lg cta-btn">
            <span>Schedule a Consultation</span>
            <i class="bi bi-arrow-right ms-2"></i>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ParticlesBackground from '@/components/ParticlesBackground.vue';

export default {
  name: 'HomePage',
  components: {
    ParticlesBackground
  }
}
</script>

<style scoped>
/* Hero Section Styles - Clean Modern Design */
.hero-section {
  position: relative;
  overflow: hidden;
  padding-top: 76px; /* Height of navbar */
  height: 100vh; /* Use viewport height */
  background: linear-gradient(135deg, #0a1930 0%, #0d2a4e 100%);
  display: flex;
  align-items: center;
}

.hero-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.6;
}

/* Content Styles */
.hero-content {
  position: relative;
  z-index: 5;
  padding: 2rem 0;
  width: 100%;
}

/* Responsive Styles for Hero Section */
@media (max-width: 991px) {
  .hero-title {
    font-size: 2.8rem;
  }
  
  .hero-stats {
    gap: 1.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}

@media (max-width: 767px) {
  .hero-section {
    padding-top: 90px; /* Increased padding for mobile navbar */
    min-height: auto;
    padding-bottom: 3rem;
  }

  .hero-content {
    padding: 1.5rem 0;
    text-align: center;
  }

  .hero-title {
    font-size: 2.2rem;
  }
  
  .hero-title-small {
    font-size: 1.2rem;
  }
  
  .hero-description {
    font-size: 1rem;
    margin-left: auto;
    margin-right: auto;
  }
  
  .hero-stats {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
  }
  
  .hero-stat {
    flex: 0 0 30%;
    margin-bottom: 0.5rem;
  }

  .hero-tag {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-cta {
    display: flex;
    justify-content: center;
  }

  .row.min-vh-100 {
    min-height: auto !important;
    padding: 2rem 0;
  }
}

/* Tag Pill */
.hero-tag {
  display: inline-flex;
  align-items: center;
  background: rgba(10, 132, 255, 0.1);
  border-radius: 50px;
  padding: 8px 16px;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(10, 132, 255, 0.2);
}

.hero-tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #0a84ff, #4cc2ff);
  border-radius: 50%;
  margin-right: 10px;
  font-size: 0.8rem;
  color: white;
}

.hero-tag-text {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: #0a84ff;
}

/* Title Styles */
.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: white;
}

.hero-title-small {
  display: block;
  font-size: 1.5rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.5rem;
}

.hero-title-main {
  display: block;
}

.text-gradient {
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Description */
.hero-description {
  font-size: 1.1rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2rem;
  max-width: 600px;
}

/* Stats Row */
.hero-stats {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
}

.hero-stat {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

/* CTA Button */
.hero-cta {
  margin-top: 2rem;
  display: flex;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  color: white;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(10, 132, 255, 0.3);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(10, 132, 255, 0.4);
}

/* Visual */
.hero-visual {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tag Pill */
.hero-tag {
  display: inline-flex;
  align-items: center;
  background: rgba(10, 132, 255, 0.1);
  border-radius: 50px;
  padding: 8px 16px;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(10, 132, 255, 0.2);
}

.hero-tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #0a84ff, #4cc2ff);
  border-radius: 50%;
  margin-right: 10px;
  font-size: 0.8rem;
  color: white;
}

.hero-tag-text {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: #0a84ff;
}

/* Title Styles */
.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: white;
}

.hero-title-small {
  display: block;
  font-size: 1.5rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.5rem;
}

.hero-title-main {
  display: block;
}

.text-gradient {
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Description */
.hero-description {
  font-size: 1.1rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2rem;
  max-width: 600px;
}

/* Bottom Wave */
.hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  line-height: 0;
  z-index: 0;
}

.hero-wave svg path {
  fill: var(--bg-primary);
}

.badge-pill {
  display: inline-block;
  padding: 0.6rem 1.2rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 2px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50px;
  color: var(--primary);
  border: 1px solid rgba(10, 132, 255, 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(10, 132, 255, 0.15);
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: var(--light);
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.text-gradient {
  background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  position: relative;
}

.text-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, var(--gradient-end), var(--gradient-start));
  opacity: 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  transition: opacity 0.5s ease;
}

.text-gradient:hover::after {
  opacity: 1;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: var(--light-muted);
  max-width: 600px;
  line-height: 1.8;
  font-weight: 400;
  letter-spacing: 0.3px;
}

/* DNA Helix Animation */
/* Visual Column */
.hero-visual-column {
  position: relative;
  z-index: 5;
}

.hero-visual {
  position: relative;
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Molecule Model */
.molecule-model {
  position: relative;
  width: 100%;
  height: 100%;
}

.dna-helix {
  position: relative;
  width: 200px;
  height: 350px;
  transform-style: preserve-3d;
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  75% {
    border-radius: 60% 40% 30% 70% / 70% 50% 50% 30%;
  }
  100% {
    border-radius: 28% 72% 70% 30% / 30% 30% 70% 70%;
  }
}

/* Section Styles */
/* Stats Row */
.hero-stats {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
}

.hero-stat {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

/* CTA Buttons */
.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn-primary {
  background: linear-gradient(90deg, #0a84ff, #4cc2ff);
  border: none;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(10, 132, 255, 0.3);
}

.btn-glow::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
  pointer-events: none;
}

.btn-glow:hover::after {
  opacity: 1;
}

.btn-outline {
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-3px);
}

.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.section-pre-title {
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--primary);
  margin-bottom: 1rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

.section-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
  margin: 0 auto 2rem;
}

/* Services Section Styles */
.services-section {
  background-color: var(--bg-primary);
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.services-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 20% 30%, rgba(10, 132, 255, 0.05) 0%, transparent 40%),
              radial-gradient(circle at 80% 70%, rgba(108, 66, 232, 0.05) 0%, transparent 40%);
  z-index: -1;
}

.section-subtitle {
  color: var(--text-muted);
  font-size: 1.1rem;
  max-width: 700px;
  margin-top: 1rem;
  line-height: 1.7;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}

.service-card {
  position: relative;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.service-card-inner {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2.5rem 2rem;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  z-index: 2;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  opacity: 0;
  border-radius: 16px;
  z-index: 0;
  transition: opacity 0.4s ease;
  filter: blur(15px);
  transform: translateY(10px) scale(0.95);
}

.service-card:hover::before {
  opacity: 0.15;
  transform: translateY(0) scale(1);
}

.service-card:hover .service-card-inner {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(255, 255, 255, 0.1);
}

.service-hover-effect {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(10, 132, 255, 0.05) 0%, rgba(108, 66, 232, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: -1;
}

.service-card:hover .service-hover-effect {
  opacity: 1;
}

.service-icon {
  position: relative;
  margin-bottom: 1.8rem;
}

.icon-hexagon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: var(--light);
  position: relative;
  z-index: 2;
}

.icon-hexagon::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  z-index: -1;
  transition: all 0.3s ease;
}

.icon-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--gradient-start);
  filter: blur(20px);
  opacity: 0.3;
  border-radius: 50%;
  z-index: 1;
  top: 0;
  left: 0;
  transform: scale(0.7);
  transition: all 0.4s ease;
}

.service-card:hover .icon-glow {
  transform: scale(1);
  opacity: 0.5;
}

.service-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--text-color);
  position: relative;
  display: inline-block;
}

.service-content h3::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
  transition: width 0.3s ease;
}

.service-card:hover .service-content h3::after {
  width: 100%;
}

.service-content p {
  color: var(--text-muted);
  margin-bottom: 1.5rem;
  line-height: 1.7;
  font-size: 0.95rem;
}

.service-link {
  display: inline-flex;
  align-items: center;
  color: var(--primary);
  font-weight: 600;
  transition: all 0.3s ease;
  text-decoration: none;
  position: relative;
  padding-bottom: 3px;
}

.service-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
  transition: width 0.3s ease;
}

.service-link:hover {
  color: var(--gradient-end);
}

.service-link:hover::after {
  width: 100%;
}

.service-link i {
  margin-left: 0.5rem;
  transition: transform 0.3s ease;
}

.service-link:hover i {
  transform: translateX(5px);
}

/* About Section Styles */
.about-section {
  position: relative;
  background-color: var(--bg-primary);
  overflow: hidden;
}

.about-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(10, 132, 255, 0.05) 0%, rgba(108, 66, 232, 0.05) 100%);
  z-index: 0;
}

.glowing-orbs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.2;
  z-index: 0;
}

.orb-1 {
  top: -100px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: var(--gradient-start);
  animation: floatOrb 15s ease-in-out infinite;
}

.orb-2 {
  bottom: -150px;
  right: -100px;
  width: 400px;
  height: 400px;
  background: var(--gradient-end);
  animation: floatOrb 20s ease-in-out infinite reverse;
}

.orb-3 {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  animation: pulseOrb 10s ease-in-out infinite;
}

@keyframes floatOrb {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(100px, 50px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes pulseOrb {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.2;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.2;
  }
}

.about-visual {
  position: relative;
  height: 450px;
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about-hologram {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hologram-container {
  position: relative;
  width: 250px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hologram-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(10, 132, 255, 0.3);
  box-shadow: 0 0 20px rgba(10, 132, 255, 0.2);
}

.ring-1 {
  width: 250px;
  height: 250px;
  animation: rotateRing 20s linear infinite;
}

.ring-2 {
  width: 200px;
  height: 200px;
  animation: rotateRing 15s linear infinite reverse;
}

.ring-3 {
  width: 150px;
  height: 150px;
  animation: rotateRing 10s linear infinite;
}

@keyframes rotateRing {
  0% {
    transform: rotateZ(0deg) rotateX(60deg) rotateY(0deg);
  }
  100% {
    transform: rotateZ(360deg) rotateX(60deg) rotateY(360deg);
  }
}

.hologram-center {
  position: absolute;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  border-radius: 50%;
  box-shadow: 0 0 30px rgba(10, 132, 255, 0.5);
  animation: pulseCenter 3s ease-in-out infinite;
}

@keyframes pulseCenter {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}

.hologram-projection {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(10, 132, 255, 0.2) 0%, transparent 70%);
  animation: pulseProjection 4s ease-in-out infinite;
}

@keyframes pulseProjection {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 0.3;
  }
}

.about-stats {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}

.about-stat {
  margin: 10px;
  transform: translateY(20px);
}

.about-stat-inner {
  width: 110px;
  height: 110px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.about-stat:hover .about-stat-inner {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  border-color: rgba(10, 132, 255, 0.3);
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--text-color);
  line-height: 1;
  margin-bottom: 5px;
  background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.stat-plus {
  font-size: 1.5rem;
  vertical-align: top;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-align: center;
  line-height: 1.2;
}

.tech-circuit {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><path d="M0,50 L100,50" stroke="rgba(10, 132, 255, 0.1)" stroke-width="0.5"/><path d="M50,0 L50,100" stroke="rgba(10, 132, 255, 0.1)" stroke-width="0.5"/><circle cx="50" cy="50" r="3" fill="rgba(10, 132, 255, 0.2)"/></svg>');
  background-size: 50px 50px;
  z-index: 0;
  opacity: 0.3;
}

.about-text {
  color: var(--text-muted);
  line-height: 1.8;
  font-size: 1.05rem;
}

.about-features {
  margin-top: 2.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.feature-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  border-color: rgba(10, 132, 255, 0.2);
}

.feature-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--light);
  margin-bottom: 1rem;
}

.feature-content h4 {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: var(--text-color);
}

.feature-content p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
  margin-bottom: 0;
}

/* Testimonials Section Styles */
.testimonials-section {
  background-color: var(--dark);
  position: relative;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 15px;
  padding: 2rem;
  height: 100%;
  transition: var(--transition);
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
}

.testimonial-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(to bottom, var(--gradient-start), var(--gradient-end));
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}

.testimonial-rating {
  margin-bottom: 1.5rem;
  color: #FFD700;
}

.testimonial-quote {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.05);
}

.testimonial-text {
  color: var(--light-muted);
  font-style: italic;
  margin-bottom: 1.5rem;
  line-height: 1.8;
  position: relative;
  z-index: 1;
}

.testimonial-author {
  display: flex;
  align-items: center;
}

.testimonial-author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 1rem;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  color: var(--light);
  font-weight: 600;
}

.testimonial-author-info h4 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  color: var(--light);
}

.testimonial-author-info p {
  font-size: 0.85rem;
  color: var(--light-muted);
  margin: 0;
}

/* CTA Section Styles */
.about-image-container {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  height: 400px;
}

.about-image-glow {
  position: absolute;
  top: -50px;
  left: -50px;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(var(--primary-rgb), 0.3) 0%, rgba(var(--primary-rgb), 0) 70%);
  border-radius: 50%;
  z-index: 1;
  filter: blur(30px);
}

.about-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  position: relative;
}

.about-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(var(--primary-rgb), 0.3), rgba(var(--secondary-rgb), 0.3));
  z-index: 3;
}

.about-dna-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  opacity: 0.8;
  pointer-events: none;
}

/* DNA Animation Styles for Hero Section */
.dna-container {
  z-index: 2;
  opacity: 0.9;
  mix-blend-mode: screen;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.hero-section .dna-container {
  right: -5%;
  transform: scale(1.2);
}

.cta-section {
  position: relative;
  padding: 6rem 0;
  overflow: hidden;
}

.cta-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(10, 132, 255, 0.2) 0%, rgba(108, 66, 232, 0.2) 100%);
  z-index: -1;
}

.cta-bg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--darker);
  opacity: 0.9;
  z-index: -1;
}

.cta-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--light);
}

.cta-text {
  color: var(--light-muted);
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
}

.cta-btn {
  padding: 0.8rem 2rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.cta-shape-1 {
  position: absolute;
  top: -50px;
  left: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--gradient-start), transparent);
  opacity: 0.1;
  z-index: -1;
}

.cta-shape-2 {
  position: absolute;
  bottom: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(135deg, transparent, var(--gradient-end));
  opacity: 0.1;
  z-index: -1;
}

/* Modern CTA Section Styles */
.cta-section-modern {
  position: relative;
  padding: 5rem 0;
  background: linear-gradient(135deg, #e6f2ff 0%, #f0f8ff 100%);
  margin: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 0 20px rgba(0, 120, 255, 0.05);
}

.cta-section-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="10" r="1" fill="rgba(0, 120, 255, 0.1)"/></svg>');
  background-size: 20px 20px;
  opacity: 0.5;
  z-index: 0;
}

.cta-content-modern {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title-modern {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--dark);
}

.cta-text-modern {
  color: var(--dark);
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
}

/* Services Explore Button */
.btn-services-explore {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 2rem;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  color: white;
  font-weight: 600;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 120, 255, 0.2);
}

.btn-services-explore:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 120, 255, 0.3);
  color: white;
}

.btn-services-explore:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(0, 120, 255, 0.2);
}

.btn-services-explore i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.btn-services-explore:hover i {
  transform: translateX(4px);
}

/* Responsive Styles */
@media (max-width: 992px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .cta-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem 0;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}
</style>
